import React from 'react';
import { FaPaperPlane, FaCheckDouble, FaCheck } from 'react-icons/fa';
import { RxCrossCircled } from "react-icons/rx";

const statusStyles = {
  base: {
    // display: 'inline-flex',
    // alignItems: 'center',
    // gap: '6px',
    // padding: '4px 8px',
    // borderRadius: '12px',
    // fontSize: '0.875rem',
    // fontWeight: '500',
    // width: 'fit-content',
  },
  requested: {
    //backgroundColor: '#fff3cd',
    //color: '#856404',
    className: "text-warning"
  },
  approved: {
    //backgroundColor: '#d4edda',
    color: '#155724',
    className: "text-success"
  },
  ["partially approved"]: {
    color: '#155724',
    className: "text-success"
  },
  rejected: {
    //backgroundColor: '#f8d7da',
    color: '#721c24',
    className: "text-danger"
  },
};

const StatusCell = ({ status }) => {
  let icon: any = null;

  switch (status?.toLowerCase()) {
    case 'requested':
      icon = <FaPaperPlane />;
      break;
    case 'partially approved':
      icon = <FaCheck />;
      break;
    case 'approved':
      icon = <FaCheckDouble />;
      break;
    case 'rejected':
      icon = <RxCrossCircled />;
      break;
    default:
      return null;
  }

  return (
    <span className={"d-flex flex-row align-items-center text-nowrap text-capitalize gap-1 " + statusStyles[status.toLowerCase()].className}>
      {icon} {status}
    </span>
  );
};

export default StatusCell;
